import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Alert } from "reactstrap";
import Layout from "../../components/Wrappers/Layout";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import BackButton from "../../components/BackButton/BackButton";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SaveIcon from "@mui/icons-material/Save";
// import SearchIcon from "@mui/icons-material/Search";
import { partnerAddUpdateNotificationConfigLists } from "../../redux/actions/addUpdateNotificationConfigPartnerAction";
import { getNotificationConfigsList } from "../../redux/actions/getNotificationConfigPartnerAction"

const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const AddNotification = () => {
    const classes = useStyles();

    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );

    var authToken = regenerateTokenRes.data.AuthToken;

    const location = useLocation();
    const dispatch = useDispatch();

    const [role, setRole] = useState("");
    const [walletRole, setWalletRole] = useState(role);
    const [notificationOpen, setNotificationOpen] = useState(false);
    const [checkListNotification, setCheckListNotification] = useState(false)

    const [addOrEditStatus, setAddOrEditStatus] = useState("add")

    const [getDataCompare, setGetDataCompare] = useState([])

    // const [getMainArr, setGetMainArr] = useState(["LOAD", "SEND", "PURCHASE", "REFUND", "RECEIVED"])

    const getWalletRolesRes = useSelector(
        ({ walletAcRequired }) => walletAcRequired
    );

    const getAddUpdateNotificationConfigRes = useSelector(
        ({ partnerAddUpdateNotificationConfigsLists }) => partnerAddUpdateNotificationConfigsLists
    );
    // const getUpdateNotificationConfigRes = useSelector(
    //     ({ partnerAddUpdateNotificationConfigsLists }) => partnerAddUpdateNotificationConfigsLists
    // );
    const getNotificationConfigRes = useSelector(
        ({ partnerGetConfigNotificationsLists }) => partnerGetConfigNotificationsLists
    );
    // 
    const [getCongigNotificStatus, setGetCongigNotificStatus] =
        useState(false);
    const [getCongigNotificResArray, setGetCongigNotificResArray] =
        useState("");

    const handleChange = ({ target: { name, value } }) => {
        // setGetMainArr([...defaultArr])
        // console.log(name, value);
        if (name === "role") {

            setRole(value);
            handleSearch(value)
        }

        if (name === "walletRole") {
            setWalletRole(value);
        }

    }
    // const [getNoneNotification, setGetNoneNotification] = useState('')
    // const [getPushNotification, setGetPushNotification] = useState('');
    // const [getEmailNotification, setGetEmailNotification] = useState('');
    // const [getSmsNotification, setGetSmsNotification] = useState('');
    // const [getTransType, setGetTransType] = useState('')

    const handleNoticationClose = () => {
        setNotificationOpen(false);
        // setCheckListNotification(false);

    };


    // const [getAllNotificationsStatus, getAllNotificationsStatus] = useState(false)
    // const [deleteMappingBankArray, setDeleteMappingBankArray] = useState("")
    const handleSearch = (role) => {
        // console.log("ROLEESSSS", role);

        if (!role) {
            // setGetCongigNotificResArray({ status: "Failed", description: "Please Select Role" })

            // setNotificationOpen(true);
        }
        else {
            getNotificationConfigReq(role)

        }

    }

    const getNotificationConfigReq = (value) => {

        // console.log("getCongigNotificStatussss", getCongigNotificStatus)

        setGetCongigNotificStatus(true);
        const reqList = {

            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                role: value
            },

        }
        dispatch(getNotificationConfigsList(reqList, authToken));
        // console.log("i made get req");

        // getNotificationConfigsFunc()
        // console.log("REQUESTTTT", reqList)
        // console.log("getCongigNotificStatussss1", getCongigNotificStatus)


    }

    useEffect(() => {
        // console.log('status res: ', getNotificationConfigRes)
        // console.log("i got get req data");
        if (getNotificationConfigRes) {
            getNotificationConfigsFunc();
        }

    }, [getNotificationConfigRes]);

    // useEffect(() => {
    //     console.log("inside useEffect", getAddUpdateNotificationConfigRes)
    //     if (getAddUpdateNotificationConfigRes.data.status) {
    //         getAddNotificationFunc();
    //     }
    // }, [getAddUpdateNotificationConfigRes]);
    useEffect(() => {
        if (getAddUpdateNotificationConfigRes.data.status && role != "") {
            getAddNotificationFunc();
        }
    }, [getAddUpdateNotificationConfigRes]);

    useEffect(() => {
        setGetMainArr([...defaultArr])
    }, [])

    const getNotificationConfigsFunc = () => {
        // console.log("GETDATA", getNotificationConfigRes)
        // console.log("getCongigNotificStatussss2", getCongigNotificStatus)

        // if (getCongigNotificStatus) {
        // console.log("GETDATA1", getNotificationConfigRes)

        if (getNotificationConfigRes.data.status === "Success") {
            // console.log("Latest arr inside for success", getNotificationConfigRes.data.list)
            setGetDataCompare([...getNotificationConfigRes.data.list])

            // setGetCongigNotificResArray([].concat(getNotificationConfigRes.data.list))
            setCheckListNotification(true)
            setGetMainArr([...getNotificationConfigRes.data.list])
            setAddOrEditStatus("edit")
            setGetCongigNotificStatus(false)
        }
        if (getNotificationConfigRes.data.status === "Failed") {
            // console.log("Latest arr inside", getNotificationConfigRes.data.list)
            // setGetCongigNotificResArray(getNotificationConfigRes.data)
            // console.log("Failed: ", getNotificationConfigRes.data);
            // console.log('defaultArr: ', defaultArr)
            setGetMainArr([...defaultArr]);
            setGetDataCompare([...defaultArr])
            setCheckListNotification(true)
            setAddOrEditStatus("add")
            setGetCongigNotificStatus(false)

        }
        if (getNotificationConfigRes.data.status === "failed") {
            // setGetCongigNotificResArray(getNotificationConfigRes.data)
            setGetMainArr([...defaultArr])
            setGetDataCompare([...defaultArr])
            setCheckListNotification(true)
            setAddOrEditStatus("add")
            setGetCongigNotificStatus(false)

        }
        // }



    }
    // useEffect(() => {
    //     getNotificationConfigsFunc()
    // }, [getNotificationConfigRes.data.status])

    // useEffect(() => {
    //     if (regenerateTokenRes.data.status == "success") {
    //         getNotificationConfigsFunc()
    //     }
    // }, [regenerateTokenRes.data.status]);

    let defaultArr = [{
        "id": "",
        "transactionType": "LOAD",
        "noneNotification": "N",
        "pushNotification": "N",
        "smsNotification": "N",
        "emailNotification": "N"
    },
    // {
    //     "id": "",
    //     "transactionType": "SEND",
    //     "noneNotification": "N",
    //     "pushNotification": "N",
    //     "smsNotification": "N",
    //     "emailNotification": "N"
    // },
    {
        "id": "",
        "transactionType": "TRANSFER",
        "noneNotification": "N",
        "pushNotification": "N",
        "smsNotification": "N",
        "emailNotification": "N"
    },
    {
        "id": "",
        "transactionType": "PURCHASE",
        "noneNotification": "N",
        "pushNotification": "N",
        "smsNotification": "N",
        "emailNotification": "N"
    },
    {
        "id": "",
        "transactionType": "REFUND",
        "noneNotification": "N",
        "pushNotification": "N",
        "smsNotification": "N",
        "emailNotification": "N"
    },
    // {
    //     "id": "",
    //     "transactionType": "RECEIVED",
    //     "noneNotification": "N",
    //     "pushNotification": "N",
    //     "smsNotification": "N",
    //     "emailNotification": "N"
    // },
    {
        "id": "",
        "transactionType": "WITHDRAW",
        "noneNotification": "N",
        "pushNotification": "N",
        "smsNotification": "N",
        "emailNotification": "N"
    },

    ]

    const [getMainArr, setGetMainArr] = useState([...defaultArr])

    // const [newArray, setNewArray] = useState([])

    const handleChangeBase = (e, index) => {
        // console.log("NEWARRR", newArray)

        // if (!newArray.includes(index)) {
        //     setNewArray([...newArray, index])

        // }
        setGetDataCompare([])


        const name = e.target.name
        const CheckValue = e.target.checked
        let ChangeValue = CheckValue === true ? "D" : "N"
        // console.log("CHECKVALUEEE", CheckValue)
        // console.log("CHANGEVAL", ChangeValue)
        // console.log("CHECKVALUEEEE", CheckValue)
        // console.log("TransactionTYPE", name)
        if (name == "noneNotification") {

            for (let i in getMainArr[index]) {
                if (i == name || i == "transactionType" || i == "id") {
                    continue
                }

                else {
                    getMainArr[index][i] = ChangeValue
                }
            }

        }
        if (name != "noneNotification") {
            getMainArr[index]["noneNotification"] = "D"
        }
        // if (getMainArr[index]["PushNotification"] === "N" && getMainArr[index]["SMS"] === "N" && getMainArr[index]["Email"] === "N") {
        //     getMainArr[index]["None"] = "N"
        // }

        getMainArr[index][name] = CheckValue ? "Y" : "N"
        // console.log("MainARRRAAAYY", getMainArr)
        setGetMainArr([...getMainArr])
        if (getMainArr[index]["pushNotification"] === "N" && getMainArr[index]["smsNotification"] === "N" && getMainArr[index]["emailNotification"] === "N") {
            getMainArr[index]["noneNotification"] = "N"
        }
    }
    const getAddNotificationFunc = () => {

        // console.log("USESELec", getAddUpdateNotificationConfigRes)

        if (getAddUpdateNotificationConfigRes.data.status === "success") {

            // console.log("getAddUpdateNotificationConfigRessssss", getAddUpdateNotificationConfigRes.data)
            setGetCongigNotificResArray(getAddUpdateNotificationConfigRes.data)

            setNotificationOpen(true);

            // console.log("am making get req");

            // getNotificationConfigReq()
            // setTimeout(() => {
            // console.log("INSIDE timeout")
            handleSearch(role)
            // console.log("AFter handlesearch")

            // }, 2000)




            // console.log("FINALRESPONSEDATA", getAddUpdateNotificationConfigRes.data.customerMasterDetailsRequestVOList)

            // setGetMainArr([].concat(getAddUpdateNotificationConfigRes.data.customerMasterDetailsRequestVOList));
            // getNotificationConfigReq()

        }
        if (getAddUpdateNotificationConfigRes.data.status === "failed") {
            // console.log("DATTTAAAA", getAddUpdateNotificationConfigRes)

            setGetCongigNotificResArray(getAddUpdateNotificationConfigRes.data)

            setNotificationOpen(true);

            // setGetMainArr(getAddUpdateNotificationConfigRes.data);
            if (
                getAddUpdateNotificationConfigRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getAddUpdateNotificationConfigRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }

        }
        if (getAddUpdateNotificationConfigRes.data.status === "Failed") {
            setGetCongigNotificResArray(getAddUpdateNotificationConfigRes.data)
            setNotificationOpen(true);
            getNotificationConfigsFunc()
            // setGetMainArr(getAddUpdateNotificationConfigRes.data);
            if (
                getAddUpdateNotificationConfigRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getAddUpdateNotificationConfigRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }
    const getAddNotificationListReq = () => {
        if (!role) {
            setGetCongigNotificResArray({ status: "Failed", description: "Please Select Role" })

            setNotificationOpen(true);
            return
        }

        if (addOrEditStatus === "add") {
            if (JSON.stringify(getMainArr) == JSON.stringify(getDataCompare)) {
                setGetCongigNotificResArray({ status: "Failed", description: "Please Select the Notification Type" })

                setNotificationOpen(true);
                return;

            }
            const req = {
                loginDetails: {
                    walletOwnerId: regenerateTokenRes.data.partnerId || "",
                    role: role
                },
                customerMasterDetailsRequestVOList: getMainArr
            }

            dispatch(partnerAddUpdateNotificationConfigLists(req, authToken));
            // getAddNotificationFunc()

        }
        else {
            if (JSON.stringify(getMainArr) == JSON.stringify(getDataCompare)) {
                setGetCongigNotificResArray({ status: "Failed", description: "No Changes Found" })

                setNotificationOpen(true);
                return;
            }
            const request = {
                loginDetails: {
                    walletOwnerId: regenerateTokenRes.data.partnerId || "",
                    role: role
                },
                customerMasterDetailsRequestVOList: getMainArr
            }
            // console.log("EDIT REQUEST", request)

            dispatch(partnerAddUpdateNotificationConfigLists(request, authToken));
            // getAddNotificationFunc()


        }

        // console.log("NOTIFICATIONSS", req)

        // console.log("FINALMAINARR", getMainArr)
        // let getNotiFicationIndex = []
        // for (let i = 0; i < getMainArr.length; i++) {
        //     console.log("inside for", getMainArr[i])
        //     for (let key in getMainArr[i]) {
        //         if (getMainArr[i][key] === "Y") {
        //             getMainArr[i].id = ""
        //             getNotiFicationIndex.push(getMainArr[i])

        //             break

        //         }

        //     }

        // }
        // console.log("FINALINDEX", getNotiFicationIndex)


    };



    // useEffect(() => {

    //     getAddNotificationFunc();

    // }, [getAddUpdateNotificationConfigRes.data.status]);






    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px" }}
                    >
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                autoFocus
                                margin="dense"
                                id="name"
                                label="Select Role"
                                fullWidth
                                variant="standard"
                                type="text"
                                name="role"
                                defaultValue={role}
                                onChange={handleChange}
                                InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
                            >
                                {/* <MenuItem selected="Select Role">
                                    Select Role
                                </MenuItem> */}
                                {getWalletRolesRes.success &&
                                    getWalletRolesRes.data.rolesList.map((x) => (
                                        <MenuItem value={x}>{x}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        {/* <Grid item xs={12} sm={12} md={4} lg={4} container>
                            <Grid>
                                <CustomButton
                                    style={{
                                        padding: "8px"
                                    }}
                                    // onClick={handleSearch}
                                >
                                    Search <SearchIcon />
                                </CustomButton>
                            </Grid>

                        </Grid> */}

                    </Grid>
                </Card>

                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px"
                        }}
                    >
                        <Grid xs={12} sm={12} md={12} lg={12}>
                            <Typography
                                variant="body1"
                                style={{ fontWeight: "700" }}
                                className="themeText"
                            >
                                Notification
                            </Typography>
                        </Grid>
                        <TableContainer component={Paper} className="my-3">
                            <Table
                                className={classes.table}
                                size="small"
                                aria-label="a dense table"
                            >
                                <TableHead>
                                    <TableRow className="tableHeaderColor">
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            Transaction Type{" "}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            None{" "}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            PUSH Notification
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            SMS
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            EMAIL
                                        </TableCell>



                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {getMainArr.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell align="center">
                                                {row.transactionType}
                                            </TableCell>
                                            <TableCell align="center">
                                                {/* {row.None} */}
                                                <input type="checkbox" name="noneNotification" checked={row.noneNotification === "Y" ? true : false} disabled={row.noneNotification === "D"} onChange={(e) => { handleChangeBase(e, index) }} />

                                            </TableCell>
                                            <TableCell align="center">
                                                {/* {row.PushNotification} */}
                                                <input type="checkbox" name="pushNotification" checked={row.pushNotification === "Y" ? true : false}
                                                    disabled={row.pushNotification === "D"}
                                                    onChange={(e) => { handleChangeBase(e, index) }} />

                                            </TableCell>
                                            <TableCell align="center">
                                                {/* {row.SMS} */}
                                                <input type="checkbox" name="smsNotification" checked={row.smsNotification === "Y" ? true : false}
                                                    disabled={row.smsNotification === "D"}

                                                    onChange={(e) => { handleChangeBase(e, index) }} />

                                            </TableCell>
                                            <TableCell align="center">
                                                {/* {row.Email} */}
                                                <input type="checkbox" name="emailNotification" checked={row.emailNotification === "Y" ? true : false}
                                                    disabled={row.emailNotification === "D"}

                                                    onChange={(e) => { handleChangeBase(e, index) }} />

                                            </TableCell>

                                        </TableRow>

                                    ))}
                                </TableBody>

                            </Table>

                        </TableContainer>
                        <CustomButton
                            style={{
                                padding: "8px",
                                marginLeft: "50%"
                            }}
                            onClick={getAddNotificationListReq}
                            endIcon={<SaveIcon />}
                        >
                            Save <SaveIcon />
                        </CustomButton>
                    </Grid>
                </Card>

            </Layout>





            {/* {console.log("Inside code and response", getCongigNotificResArray)} */}
            {getCongigNotificResArray.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                        style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {getCongigNotificResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            {/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {getCongigNotificResArray.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                        style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {getCongigNotificResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            {/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {getCongigNotificResArray.status == "Failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                        style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {getCongigNotificResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            {/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default AddNotification